import { Typography, Box, Stack } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import Panel from "./Panel";

export default function FieldMappingPanel({ fieldMappingRows, onPageRoute, hasHeaderRow }) {
  return (
    <Box sx={{ marginTop: "80px" }}>
      <Panel title="Field Mapping">
        <Box p={5}>
          <Typography variant="body2">
            Review the details of the field mapping currently in use. To change your field mapping settings, do so on
            the
            <MzButton onClick={onPageRoute}>
              <Typography variant="button2">Field Mapping</Typography>
            </MzButton>
            page.
          </Typography>

          {hasHeaderRow && (
            <Stack direction="row" pt={2} sx={{ paddingLeft: "20px" }}>
              <Typography variant="body2B" color="blue.c100">
                Row 1: &nbsp;
              </Typography>
              <Typography variant="body2">Header Row Skipped</Typography>
            </Stack>
          )}

          <Box
            display="flex"
            spacing={2}
            mt={2}
            sx={{ paddingLeft: "20px" }}
            flexWrap="wrap"
            height="200px"
            alignContent={"flex-start"}
            gap={2}
            flexDirection="column"
          >
            {fieldMappingRows.map((item, index) => (
              <Stack direction="row" width="293px">
                <Typography variant="body2B" color="blue.c100">
                  Column {item.fieldOrder}: &nbsp;
                </Typography>
                <Typography variant="body2">{item.fieldName}</Typography>
              </Stack>
            ))}
          </Box>
        </Box>
      </Panel>
    </Box>
  );
}
